module.exports = __webpack_public_path__ + "media/images/impressions_icon-c7b1c8ab5422871f4cb90cf9c6e63626.svg";